import { useState, useContext } from "react";
import {
  Button,
  Dialog,
  Grid,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";
import { appLogger, Http } from "../../../utils";

import { useParams } from "react-router-dom";

import CustomInput from "../../../components/CustomInput";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleFetchStoredDocuments: () => void;
}

const CreateFolderModal = ({
  open,
  onClose,
  handleFetchStoredDocuments,
}: IProps) => {
  const { productId, versionId } = useParams();
  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const [folderName, setFolderName] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleValidFolderName = (str: string) => {
    const patternName = /^[a-zA-Z0-9]+$/;
    // const patternNameNoTwoDots = /^(?!.*\.{2}).*$/;
    // const patternNotValidIP = /^(?!(?:\d{1,3}\.){3}\d{1,3}$)\S+$/;

    const isValidName = patternName.test(str);
    // const isValidNameNoTwoDots = patternNameNoTwoDots.test(str);
    // const isNotValidIP = patternNotValidIP.test(str);

    return {
      isValidName,
      // isValidNameNoTwoDots,
      // isNotValidIP,
    };
  };

  const handleValidateFolderName = (folder: string) => {
    if (!folder) {
      setErrorMessage("Please enter a foldername");
      return false;
    }

    if (folder) {
      const { isValidName /*, isValidNameNoTwoDots, isNotValidIP*/ } =
        handleValidFolderName(folder);

      if (folder.length < 3) {
        setErrorMessage("Folder name must be more than 3 characters.");
        return false;
      }
      if (folder.length > 63) {
        setErrorMessage("Folder name must be less than 63 characters.");
        return false;
      }

      if (!isValidName) {
        setErrorMessage(
          "The name must contain only lowercase letters, uppercase letters or digits and not contain any spaces and special characters"
        );
        return false;
      }
    }

    setErrorMessage("");
    return true;
  };

  const handleChange = (e: any) => {
    setErrorMessage("");
    const { value } = e.target;
    handleValidateFolderName(value);
    setFolderName(value);
  };

  const handleCreateFolder = async () => {
    if (errorMessage) {
      return;
    }

    try {
      setLoading(true);
      const res: any = await Http.post({
        url: `/api/v2/kbArticles/folder`,
        state: userInfo,
        body: {
          productId: productId,
          productVersion: versionId,
          folderName: folderName,
        },
      });
      if (res?.status === "Folder already exists") {
        setLoading(false);
        setErrorMessage("Folder already exists");
        return;
      }
      if (res) {
        handleFetchStoredDocuments();
        onClose();
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      appLogger.error({
        errObj: {
          method: "handleCreateFolder",
          component: "CreateFolderModal",
          fileName: "CreateFolderModal.tsx",
          err: err,
        },
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "19px",
        },
      }}
    >
      <Grid
        container
        justifyContent="end"
        sx={{
          padding: "12px 10px",
        }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid
        container
        justifyContent="center"
        sx={{
          padding: "12px 10px",
        }}
      >
        <Typography
          sx={{
            color: "#111d3b",
            fontSize: "25px",
            fontWeight: 500,
          }}
        >
          Create Folder
        </Typography>
      </Grid>
      <Grid
        container
        sx={{
          padding: "0px 30px",
        }}
      >
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            color: "#00000099",
          }}
        >
          {/* Enter folder name below */}
          Folder names must contain only upper case letters, lower case letters
          and numbers. It cannot contain special characters or any whitespaces.
        </Typography>
      </Grid>
      <Grid
        container
        sx={{
          padding: "30px",
        }}
      >
        <Grid item xs={12}>
          <CustomInput
            name="folderName"
            value={folderName}
            onChange={handleChange}
            label="Enter folder name below"
            placeholder="Folder name"
            id="ConfirmationCode"
            type="text"
            error={errorMessage !== ""}
            helperText={errorMessage}
            sx={{
              background: "#FFF",
            }}
          />
        </Grid>
        <Grid item xs={12} mt="32px">
          <Button
            variant="contained"
            fullWidth
            onClick={handleCreateFolder}
            disabled={loading}
          >
            CREATE
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default CreateFolderModal;
